import { Pipe, PipeTransform } from '@angular/core';
import { Address, AddressNew } from '@erm/cluster';
import { convertKeysToCamelCase, convertKeysToSnakeCase } from '@shared/utils';

@Pipe({
  name: 'addressFormat',
})
export class AddressFormatPipe implements PipeTransform {
  transform(address: Address | AddressNew): string {
    address = convertKeysToSnakeCase(address) as unknown as Address;
    if (!address) {
      return '';
    }
    const addressConverted = convertKeysToCamelCase(address) as Address;

    const addressLines: string[] = [];

    // First line with address1, address2, address3
    let firstLine = addressConverted.address1;
    if (address.address2) {
      firstLine += `, ${address.address2}`;
    }
    if (address.address3) {
      firstLine += `, ${address.address3}`;
    }
    addressLines.push(firstLine);

    // Second line with city, state, zip, country
    const secondLine = `${address.city}, ${address.state} ${address.zip_code}, ${address.country?.name || ''}`;
    addressLines.push(secondLine);

    return addressLines.join('<br/>');
  }
}
